module.exports = __webpack_public_path__ + "img/card-coupon-amount-icon.d5c76528.png";